import { Directive, ElementRef, OnInit, HostListener, Input, AfterViewInit, Renderer2 } from '@angular/core';
import { AnimationPlayer, AnimationBuilder, animate, style } from '@angular/animations';

import { animations } from './model/data';
declare var $: any;

@Directive({
  selector: '[contentAnim]',
  standalone: true
})
export class ContentAnimDirective implements OnInit, AfterViewInit {

  @Input() aniName = 'fadeIn'; // Default animation
  @Input() duration = '1.3s';
  @Input() offset = 0;
  private hasAnimated = false;

  first = true;
  player: AnimationPlayer | any;

  constructor(private el: ElementRef, private animationBuilder: AnimationBuilder, private renderer: Renderer2) { }

  ngOnInit() {
    // Initial setup (if any required)
  }

  ngAfterViewInit() {
    if (this.aniName === 'scrolldown') {
      this.setupInitialStyles();
      this.observeScroll();
    }
    if (this.aniName === 'parallax') {
      this.setupParallax();
      this.observeScroll();
    }
    if (this.aniName === 'flip3D') {
      this.setupFlip3D();
      this.observeScroll();
    }
    if (this.aniName === 'floating') {
      this.setupFloating();
      this.observeScroll();
    }
    if (this.aniName === 'morphing') {
      this.setupMorphing();
      this.observeScroll();
    }

    this.el?.nativeElement?.classList?.add('appear-animate');
    this.createAnimation();

    setTimeout(() => {
      this.handleAnimation();

      let slider = this.el.nativeElement.closest('owl-carousel');
      let self = this;

      if (slider) {
        $(slider).on('translate.owl.carousel', () => {
          if (self.el.nativeElement.closest('.owl-item:not(.active)')) {
            self.el.nativeElement.classList.add('appear-animate');
          }
        });

        $(slider).on('translated.owl.carousel', () => {
          if (self.el.nativeElement.closest('.owl-item.active')) {
            if (self.el.nativeElement.classList.contains('appear-animate')) {
              self.el.nativeElement.classList.remove('appear-animate');
              this.player.play();
              this.first = false;
            }
          } else {
            self.el.nativeElement.classList.add('appear-animate');
          }
        });
      }
    }, 300);
  }

  // Animation setup functions
  setupFlip3D() {
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'rotateY(180deg) scale(0.8)');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(this.el.nativeElement, 'transition', `transform 1s ease-out, opacity 1s ease-out`);
  }

  setupParallax() {
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(100px)');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(this.el.nativeElement, 'transition', `transform 1s ease-out, opacity 1s ease-out`);
  }

  setupFloating() {
    this.renderer.setStyle(this.el.nativeElement, 'animation', 'floating 3s ease-in-out infinite');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
  }

  setupMorphing() {
    this.renderer.setStyle(this.el.nativeElement, 'animation', 'morphing 2s ease-in-out forwards');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
  }

  setupInitialStyles() {
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(0px, 50px, 0px) scale3d(1,1,1) rotateX(10deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)');
    this.renderer.setStyle(this.el.nativeElement, 'transform-style', 'preserve-3d');
    this.renderer.setStyle(this.el.nativeElement, 'transition', `opacity 1s ease-out, transform 1s ease-out`);

    const childElements = this.el.nativeElement.children;
    Array?.from(childElements).forEach((child, index) => {
      const element = child as HTMLElement;
      this.renderer.setStyle(element, 'opacity', '0');
      this.renderer.setStyle(element, 'transform', 'translate3d(0px, 30px, 0px) scale3d(1,1,1) rotateX(10deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)');
      this.renderer.setStyle(element, 'transition', `opacity 0.6s ease-out ${index * 0.3}s, transform 0.6s ease-out ${index * 0.3}s`);
    });
  }

  observeScroll() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.animateElement();
          }
        });
      },
      { rootMargin: '0px', threshold: 0.01 }
    );

    observer.observe(this.el.nativeElement);
  }

  animateElement() {
    if (this.aniName === 'scrolldown') {
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(0px, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)');

      const childElements = this.el.nativeElement.children;
      Array?.from(childElements).forEach((child) => {
            const element = child as HTMLElement;
        this.renderer.setStyle(element, 'opacity', '1');
        this.renderer.setStyle(element, 'transform', 'translate3d(0px, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)');
      });
    }
    if (this.aniName === 'parallax') {
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(0)');
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }

    if (this.aniName === 'flip3D') {
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'rotateY(0) scale(1)');
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }
    if (this.aniName === 'floating') {
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }
    if (this.aniName === 'morphing') {
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }
  }

  @HostListener('window:scroll', ['$event'])
  onscroll() {
    this.handleAnimation();
  }

   handleAnimation() {
    const nativeEl = this.el.nativeElement;

    // Validate the element is an HTMLElement
    if (!(nativeEl instanceof HTMLElement)) {
      console.warn('contentAnim directive used on non-DOM element');
      return;
    }

    const rect = nativeEl.getBoundingClientRect();

    const isVisible =
      (window.innerHeight > rect.top && rect.top > 0) ||
      (rect.bottom > 0 && rect.bottom < window.innerHeight);

    if (isVisible && this.first) {
      const carouselItem = nativeEl.closest('owl-carousel');
      const isActive = nativeEl.closest('.owl-item.active');

      if (carouselItem && !isActive) return;

      if (this.player) {
        this.player.play();
        this.first = false;
      }
    }
  }

  createAnimation() {
    // Check if the animation exists in the animations object
    if (this.aniName && animations[this.aniName as keyof typeof animations]) {
      this.player = this.animationBuilder
        .build([
          style(animations[this.aniName as keyof typeof animations]['from']),
          animate(this.duration, style(animations[this.aniName as keyof typeof animations]['to']))
        ])
        .create(this.el.nativeElement);


      let self = this;

      this.player.onStart(function () {
        self.el.nativeElement.classList.remove('appear-animate');
      });
    } else {
      console.error(`Animation "${this.aniName}" not found in animations.`);
    }
  }
}
